<div class="jumbotron text-left">
  <div class="container">
    <div class="row">
      <div class="col" style="text-align: left;">
        <!-- <h4>{{ year }}</h4> -->
      </div>
    </div>
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <div class="btn-group duration-toggle" role="group">
          <input
            type="radio"
            class="btn-check"
            name="reportMode"
            id="reportModeMonth"
            [checked]="reportMode === 'month'"
            (change)="setReportMode('month')"
          />
          <label class="btn btn-outline-secondary" [class.active]="reportMode === 'month'" for="reportModeMonth">Monthly</label>
          <input
            type="radio"
            class="btn-check"
            name="reportMode"
            id="reportModeDay"
            [checked]="reportMode === 'day'"
            (change)="setReportMode('day')"
          />
          <label class="btn btn-outline-secondary" [class.active]="reportMode === 'day'" for="reportModeDay">Daily</label>
        </div>
      </div>
      @if (reportMode === 'month') {
        <div class="col-auto">
          <label for="monthYear" class="col-form-label">Month</label>
        </div>
        <div class="col-auto">
          <input type="month" id="monthYear" class="form-control" aria-describedby="inputHelpInline" [(ngModel)]="report_date">
        </div>
      } @else {
        <div class="col-auto">
          <label for="reportDay" class="col-form-label">Day</label>
        </div>
        <div class="col-auto">
          <input type="date" id="reportDay" class="form-control" [(ngModel)]="report_day">
        </div>
      }
      <div class="col-auto">
        <span id="inputHelpInline" class="form-text">
          {{ reportMode === 'day' ? 'Select a day for the daily report.' : 'Select a month for the monthly report.' }}
        </span>
      </div>
      <div class="col-auto">
        <span id="getReport" class="form-text">
          <button type="button" class="btn btn-success" (click)="getReportSpecific()">Get Report</button>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <br>
        </div>
      </div>
      <div class="row">
        <h3>{{ reportHeading }}</h3>
        <div class="table-responsive">
          <table class="table table-bordered text-left" id="excel-table">
            <thead>
              <tr class="table-secondary">
                <th></th>
                <th>Total</th>
                @for (staff of staffs; track staff.id || staff.name) {
                  <th>
                    {{staff.name}}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                <td [attr.colspan]="staffs.length + 2" class="section-heading">
                  <h2>Patients Balance</h2>
                </td>
              </tr>
              <tr>
                <td>Number of Appointments</td>
                <td>{{ report?.appointments?.total ?? 0 }}</td>
                @for (staff of staffs; track staff.id || staff.name) {
                  <td>{{getByStaff(staff, 'G')}}</td>
                }
              </tr>
              <tr>
                <td>Number of Patients</td>
                <td>{{ report?.new_patients?.total ?? 0 }}</td>
                @for (staff of staffs; track staff.id || staff.name) {
                  <td>{{getByStaff(staff, 'A')}}</td>
                }
              </tr>
              <tr>
                <td [attr.colspan]="staffs.length + 2" class="section-heading">
                  <h2>Item Selling Balance</h2>
                </td>
              </tr>
              <tr>
                <td>No of Medical report Request </td>
                <td>{{ report?.medical_report_requests?.total ?? 0 }}</td>
                @for (staff of staffs; track staff.id || staff.name) {
                  <td>{{getByStaff(staff, 'B')}}</td>
                }
              </tr>
              <tr>
                <td>Fees of medical reports </td>
                <td>{{ report?.medical_report_requests?.total_fees ?? 0 }}</td>
                @for (staff of staffs; track staff.id || staff.name) {
                  <td>{{getByStaff(staff, 'F')}}</td>
                }
              </tr>
              <tr>
                <td [attr.colspan]="staffs.length + 2" class="section-heading">
                  <h2>Physiotherapy Service Balance</h2>
                </td>
              </tr>
              @for (s of services; track s.service_name) {
                <tr>
                  <td>
                    {{s.service_name}}
                  </td>
                  <td>
                    <div class="service-metric">
                      <span class="count">{{ s.appointments_count ?? 0 }} appts</span>
                      <span>{{ s.income | number:'1.0-3' }}</span>
                    </div>
                  </td>
                  @for (staff of staffs; track staff.id || staff.name) {
                    <td>
                      <div class="service-metric">
                        <span class="count">{{ getByStaff(staff, 'N', s.service_name) }} appts</span>
                        <span>{{ getByStaff(staff, 'C', s.service_name) | number:'1.0-3' }}</span>
                      </div>
                    </td>
                  }
                </tr>
              }
              <tr style="background-color: beige;">
                <td><strong>Total Fees:</strong></td>
                <td>
                  <div class="service-metric">
                    <span class="count"><strong>{{ totalServicesAppointments }} appts</strong></span>
                    <span><strong>{{ totalServicesIncome | number:'1.0-3' }} OMR</strong></span>
                  </div>
                </td>
                @for (staff of staffs; track staff.id || staff.name) {
                  <td>
                    <div class="service-metric">
                      <span class="count"><strong>{{ getByStaff(staff, 'J') }} appts</strong></span>
                      <span><strong>{{ getByStaff(staff, 'I') | number:'1.0-3' }}</strong></span>
                    </div>
                  </td>
                }
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</div>
